import UserRoleList from './UserRoleList';

export default UserRoleList;
